<app-web-full-page-layout>

    <div id="titleSection" class="flex flew-row w-full px-6">
        <div class="flex grow h-full items-center">
            <h1 class="font-bold text-gray-800" [class.text-3xl]="!isHandset" [class.text-2xl]="isHandset">{{ (page$ | async)?.seasonDetails?.name ?? 'Loading' }}</h1>
        </div>
        <div class="flex items-center">
            <button (click)="share()">Share</button>
        </div>
    </div>

    <div class="w-full">

        <ng-container *ngIf="!(page$ | async)">
            <div class="px-6 py-8 bg-slate-100">
                <span class="text-base bg-white border-1 border-slate-300 py-2 px-5 rounded-full">Loading</span>
            </div>
        </ng-container>

        <ng-container *ngIf="(page$ | async)">
            <div class="w-full">
               <router-outlet></router-outlet>
            </div>
        </ng-container>

    </div>

</app-web-full-page-layout>
